export default "__VITE_ASSET__f54a0209__"